import ScreenUtils from '@screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const MenuCollapseContainer = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: ${480 * ScreenUtils.widthRatio}px;
  height: ${1080 * ScreenUtils.widthRatio}px;
  width: ${64 * ScreenUtils.widthRatio}px;
`;

export default withAnimation(MenuCollapseContainer);
